<template>
    <div class="relative">
        <button
            id="language-select-btn"
            type="button"
            class="text-sm border rounded px-2 py-1 bg-white flex items-center gap-2 min-w-[80px]"
            @click="toggleDropdown"
        >
            <img
                v-if="currentLanguage?.flag"
                :src="flagSrc(currentLanguage.flag)"
                alt="Flag"
                class="w-5 h-5 object-contain"
            >
            <span>{{ currentLanguage?.code_view || '' }}</span>
            <svg class="w-4 h-4 ml-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
        </button>
        <div
            v-show="isOpen"
            class="absolute bg-white border h-64 left-0 min-w-[80px] mt-1 overflow-y-auto rounded shadow-lg top-full w-48 z-50"
        >
            <button
                v-for="lang in languages"
                :key="lang.code"
                type="button"
                class="language-option w-full text-left px-3 py-2 hover:bg-gray-100 flex items-center gap-2"
                :class="{ 'bg-blue-50': isCurrentLanguage(lang.code) }"
                @click="selectLanguage(lang)"
            >
                <img
                    v-if="lang.flag"
                    :src="flagSrc(lang.flag)"
                    alt="Flag"
                    class="w-5 h-5 object-contain"
                >
                <span>{{ lang.code_view }}</span>
            </button>
        </div>
    </div>
</template>

<script>
import { flagSrc } from '../../utils/flagSrc.js';

export default {
    name: 'SelectAppLanguage',
    data() {
        return {
            isOpen: false
        }
    },
    computed: {
        languages() {
            return this.$store.getters.languages || [];
        },
        currentLanguage() {
            return this.$store.getters.lang || this.languages[0] || {};
        }
    },
    mounted() {
        // Close dropdown when clicking outside
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    methods: {
        flagSrc,
        toggleDropdown(e) {
            e.stopPropagation();
            this.isOpen = !this.isOpen;
        },
        handleClickOutside(e) {
            if (!this.$el.contains(e.target)) {
                this.isOpen = false;
            }
        },
        isCurrentLanguage(code) {
            return code?.toLowerCase() === this.currentLanguage?.code?.toLowerCase();
        },
        selectLanguage(lang) {
            this.isOpen = false;

            // Redirect to new language
            const langCode = lang.code;
			const path = this.$store.state.page.paths_by_language[langCode];

			window.location.replace(path);
        }
    }
}
</script>

